import { checkboxAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys)

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/checkbox.ts}
 */
export const Checkbox = defineMultiStyleConfig({
  baseStyle: {
    control: {
      border: "1px solid",
      borderColor: "border.primary",
      background: "surface.page",
      w: "1.125rem",
      h: "1.125rem",
      _checked: {
        bg: "surface.action",
        borderColor: "surface.action",
        color: "white",

        _hover: {
          bg: "main.900",
          borderColor: "main.900",
        },

        _focus: {
          bg: "main.700",
        },

        _disabled: {
          bg: "neutrals.200",
          color: "neutrals.700",
          borderColor: "neutrals.400",
        },
      },

      _focus: {
        borderColor: "main.700",
      },

      _disabled: {
        bg: "neutrals.100",
        borderColor: "neutrals.100",
      },

      _indeterminate: {
        bg: "surface.action",
        borderColor: "surface.action",
        color: "white",
      },
      svg: {
        animation: "none",
      },
    },
    label: {
      py: 1,
      lineHeight: 1.57143,
      flexGrow: 2,
    },
  },
  sizes: {
    sm: {
      label: {
        fontSize: 12,
      },
    },
    md: {
      label: {
        fontSize: 14,
      },
    },
  },
  defaultProps: {
    size: "md",
    colorScheme: "primary",
  },
})
